import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { sizes } from '../media';
export const useIsPhone = (PHONE_BREAKPOINT = sizes.mobileLandscape) => {
    const [isPhone, setIsPhone] = React.useState(window.innerWidth <= PHONE_BREAKPOINT);
    const [handleWindowResize] = useDebouncedCallback(() => setIsPhone(window.innerWidth <= PHONE_BREAKPOINT), 250);
    React.useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    });
    return isPhone;
};
//# sourceMappingURL=isPhone.js.map